import React from 'react';
import { Row, Col, Card, Table, Button, Typography, Skeleton, Flex } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const RecentEstimatesSection = ({ loading, stats, navigate, estimateColumns }) => (
  <Row gutter={[24, 24]} align="top">
    <Col xs={24} md={8}>
      <Title level={5} className="customer-dashboard-section-title">
        Recent Estimates
      </Title>
      <Text type="secondary" className="customer-dashboard-section-text">
        Your latest estimate. View all estimates for the full history.
      </Text>
    </Col>
    <Col xs={24} md={16}>
      <Card
      variant="borderless"
      className="shadow-none border-none"
        size="small"
        extra={
          <Button
            type="link"
            icon={<ArrowRightOutlined />}
            onClick={() => navigate('/estimates')}
            style={{ padding: 0, fontWeight: 500 }}
          >
            View all
          </Button>
        }
        styles={{ body: { padding: 0 } }}
      >
        {loading ? (
          <Flex justify="center" style={{ padding: 24 }}>
            <Skeleton active paragraph={{ rows: 4 }} />
          </Flex>
        ) : (
          <Table
            dataSource={stats?.recent_activity?.last_estimate ? [stats.recent_activity.last_estimate] : []}
            columns={estimateColumns}
            rowKey={(r) => r.public_id ?? r.id ?? 'est'}
            pagination={false}
            scroll={{ x: 'max-content' }}
            size="small"
            locale={{ emptyText: 'No estimates yet' }}
          />
        )}
      </Card>
    </Col>
  </Row>
);

export default RecentEstimatesSection;
